import { Component, Input } from '@angular/core';
import { CPatient } from '@models/imported/SagaSchema/CPatient';

@Component({
  selector: 'app-callcard-cpatient-card',
  templateUrl: './callcard-cpatient-card.component.html',
  styleUrls: ['./callcard-cpatient-card.component.scss']
})
export class CallcardCpatientCardComponent {
  @Input() patient: CPatient;

  constructor() {}

  call(phoneNumber: string) {
    window.open(`tel: ${phoneNumber}`);
  }
}
